import intialState from './ConfigurationInitialState';
import reducers from './ConfigurationReducer';

export default {
  intialState,
  reducers,
};
